import React from 'react';
import OutboundLink from '../common/OutboundLink';

const GalleryLogo = () => (
  <OutboundLink href="https://www.gallerymediagroup.com/" className="gallery-logo">
    <img className="gallery-logo-img" src="https://static.cdn.gallerymediagroup.com/one37pm/logos/Gallery_Media_Group_Logo.svg" alt="Gallery Media Group logo" />
  </OutboundLink>
);

export default GalleryLogo;
